import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAWx0B-RjAFk8-kLoIs87mEh7osuhSdTbw",
  authDomain: "trivia-5dbab.firebaseapp.com",
  projectId: "trivia-5dbab",
  storageBucket: "trivia-5dbab.firebasestorage.app",
  messagingSenderId: "464844213601",
  appId: "1:464844213601:web:59798c21264167dd944920"
};

// Initialize Firebase only if it hasn't been initialized
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// Initialize Firestore
const db = getFirestore(app);

export { db };
